import React from 'react'

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {

    }
    this.documentsTable = React.createRef()
  }

  componentDidMount(){

  }

  render() {

    let {

    } = this.state

    return (
      <>
        <div className={"row"}>

        </div>
      </>
    )
  }
}
